import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabaseClient'
import { useNavigate } from 'react-router-dom'
import ConfirmModal from '../components/ConfirmModal'
import { useLanguage } from '../hooks/useLanguage'
import { useToast } from '../components/useToast' 

export default function Amigos() {

  const { t } = useLanguage()

  const toast = useToast() 

  const navigate = useNavigate()

  const [confirmDeleteFriendId, setConfirmDeleteFriendId] = useState(null)

  const [user, setUser] = useState(null)

  const [friendId, setFriendId] = useState('')

  const [friends, setFriends] = useState([])

  const [pendingRequests, setPendingRequests] = useState([])

  const [loading, setLoading] = useState(true)

  const [sending, setSending] = useState(false)

  const cleanId = friendId.trim().toUpperCase()

  const [showAcceptModal, setShowAcceptModal] =
  useState(false)

  const [selectedRequest, setSelectedRequest] =
    useState(null)

  const [friendNickname, setFriendNickname] =
    useState('')

    function getAvatarUrl(path) {

    if (!path) return ''

    const {
      data: { publicUrl }
    } = supabase.storage
      .from('avatars')
      .getPublicUrl(path)

    return publicUrl
  }

  useEffect(() => {
    loadData()
  }, [])

  async function loadData() {

    const { data } = await supabase.auth.getUser()

    if (!data.user) {
      navigate('/login')
      return
    }

    setUser(data.user)

    // TRAER AMIGOS
const { data: friendsData } = await supabase
  .from('friends')
  .select('*')
  .or(
    `user_id.eq.${data.user.id},friend_id.eq.${data.user.id}`
  )
  .eq('status', 'accepted')

if (friendsData) {

  // ids reales de amigos
  const friendIds = friendsData.map((f) =>

    f.user_id === data.user.id
      ? f.friend_id
      : f.user_id
  )

  // perfiles reales
  const { data: profilesData } = await supabase
    .from('profiles')
    .select(`
      id,
      full_name,
      avatar_path,
      friend_id
    `)
    .in('id', friendIds)

  // unir datos
  const formattedFriends =
    friendsData.map((friend) => {

      const realFriendId =
        friend.user_id === data.user.id
          ? friend.friend_id
          : friend.user_id

      const profile =
        profilesData?.find(
          (p) => p.id === realFriendId
        )

      return {

        ...friend,

        profile

      }

    })

  setFriends(formattedFriends)

}

// SOLICITUDES PENDIENTES
const { data: pendingData } = await supabase
  .from('friends')
  .select('*')
  .eq('friend_id', data.user.id)
  .eq('status', 'pending')

if (pendingData && pendingData.length > 0) {

  // ids de quienes enviaron solicitud
  const senderIds =
    pendingData.map((r) => r.user_id)

  // buscar perfiles
    const { data: profilesData } = await supabase
    .from('profiles')
    .select(`
        id,
        full_name,
        avatar_path,
        friend_id
    `)
    .in('id', senderIds)

    console.log('PENDING:', pendingData)
    console.log('PROFILES:', profilesData)
 
    // unir datos
    const requestsWithProfiles =
    pendingData.map((request) => {

        const profile = profilesData?.find(
        (p) =>
            String(p.id) ===
            String(request.user_id)
        )
        return {

          ...request,

          profile: profile || null

        }

    })
    
  console.log(requestsWithProfiles)
  setPendingRequests(requestsWithProfiles)

} else {

  setPendingRequests([])

}

    setLoading(false)
  }

async function sendFriendRequest() {

  if (!friendId.trim()) {
    toast.warning(t('amigos_alert_ingresa_id'))
    return
  }

  setSending(true)

  // 🔍 BUSCAR USUARIO POR FRIEND_ID
  const { data: profile, error: profileError } =
    await supabase
      .from('profiles')
      .select('*')
      .eq('friend_id', cleanId)
      .single()

      console.log(profile)
      console.log(profileError)

  if (profileError || !profile) {

    console.log(profileError)

    toast.error(t('amigos_alert_no_existe'))

    setSending(false)
    return
  }

  // UUID REAL
  const realFriendUserId = profile.id

  // NO AGREGARSE A SI MISMO
  if (realFriendUserId === user.id) {

    toast.error(t('amigos_alert_no_agregarte'))

    setSending(false)
    return
  }

  // VERIFICAR SI YA EXISTE
  const { data: existing } = await supabase
    .from('friends')
    .select('*')
    .or(
      `and(user_id.eq.${user.id},friend_id.eq.${realFriendUserId}),and(user_id.eq.${realFriendUserId},friend_id.eq.${user.id})`
    )

  if (existing && existing.length > 0) {

    toast.warning(t('amigos_alert_ya_existe'))

    setSending(false)
    return
  }

// 🚀 CREAR SOLICITUD
const { data: friendRow, error } = await supabase
  .from('friends')
  .insert({
    user_id: user.id,
    friend_id: realFriendUserId,
    status: 'pending'
  })
  .select()
  .single()

if (error) {
  console.log('ERROR COMPLETO:', error)
  toast.error(t('amigos_alert_error_enviar'))
  setSending(false)
  return
}

// 🔔 NOTIFICAR AL DESTINATARIO
const myProfile = await supabase
  .from('profiles')
  .select('full_name, avatar_path, friend_id')
  .eq('id', user.id)
  .single()

const { error: notiError } = await supabase.from('notifications').insert({
  user_id: realFriendUserId,
  type: 'friend_request',
  title: '¡Nueva solicitud de amistad!',
  message: `${myProfile.data?.full_name || 'Alguien'} quiere agregarte como amigo`,
  read: false,
  metadata: {
    from_user_id: user.id,
    from_name: myProfile.data?.full_name || '',
    from_avatar: myProfile.data?.avatar_path || '',
    from_friend_id: myProfile.data?.friend_id || '',
    friend_row_id: friendRow.id
  }
})
if (notiError) {
  toast.warning(t('amigos_alert_demasiadas'))
  setSending(false)
  return
}

toast.success(t('amigos_alert_enviada'))
setFriendId('')
setSending(false)
}

async function acceptRequest() {
  if (!selectedRequest) return
  if (friendNickname.trim().length > 30) { 
    toast.warning(t('amigos_alert_nickname_max'))
    return 
  }

  if (!selectedRequest) return

const updateData = {
  status: 'accepted'
}

if (selectedRequest.user_id === user.id) {

  updateData.nickname_user =
    friendNickname

} else {

  updateData.nickname_friend =
    friendNickname
}

const { error } = await supabase
  .from('friends')
  .update(updateData)
  .eq('id', selectedRequest.id)

  if (error) {

    console.log(error)

    toast.error(
      t('amigos_alert_error_aceptar')
    )

    return
  }

  toast.success(t('amigos_alert_amigo_agregado'))

  setShowAcceptModal(false)

  setSelectedRequest(null)

  setFriendNickname('')

  loadData()
}

async function confirmarEliminarAmigo() {
  const { error } = await supabase.from('friends').delete().eq('id', confirmDeleteFriendId)
  if (error) { toast.error(t('amigos_alert_error_eliminar')); return }
  setConfirmDeleteFriendId(null)
  toast.success(t('amigos_alert_amigo_eliminado'))
  loadData()
}

async function rejectRequest(requestId) {

  const { error } = await supabase
    .from('friends')
    .delete()
    .eq('id', requestId)

  if (error) {

    console.log(error)

    toast.error(t('amigos_alert_error_rechazar'))
    return
  }

  loadData()
}
if (loading) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 20, background: 'var(--color-bg)' }}>
      <div style={{ width: 70, height: 70, borderRadius: 20, background: 'linear-gradient(135deg, #3b82f6, #6366f1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32, animation: 'pulse 1.5s infinite' }}>🛰️</div>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--color-text)', marginBottom: 6 }}>{t('amigos')}</div>
        <div style={{ fontSize: 14, color: 'var(--color-muted)' }}>{t('amigos_sincronizando')}</div>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        {[0,1,2].map(i => <div key={i} style={{ width: 10, height: 10, borderRadius: '50%', background: '#3b82f6', animation: `bounce 0.6s infinite ${i * 0.15}s` }} />)}
      </div>
      <style>{`
        @keyframes pulse { 0%,100%{transform:scale(1);opacity:1} 50%{transform:scale(1.08);opacity:0.85} }
        @keyframes bounce { 0%,80%,100%{transform:translateY(0);opacity:0.5} 40%{transform:translateY(-8px);opacity:1} }
      `}</style>
    </div>
  )
}

return (
  <div
    style={{
      minHeight: '100vh',
      background: 'var(--color-bg)',
      padding: 20
    }}
  >
{/* HEADER */}
<div
  style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    marginBottom: 26,
  }}
>

  {/* IZQUIERDA */}
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 14,
      minWidth: 0
    }}
  >

    {/* FOTO */}
    <div style={{
      width: 58,
      height: 58,
      borderRadius: '50%',
      overflow: 'hidden',
      border: '2px solid var(--color-border)',
      background: 'var(--color-primary-lt)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0
    }}>
      {user?.user_metadata?.avatar_url ? (
        <img
          src={user.user_metadata.avatar_url}
          alt="avatar"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        <span style={{ fontSize: 22, fontWeight: 700, color: 'var(--color-primary)' }}>
          {(user?.user_metadata?.display_name || 'U').charAt(0).toUpperCase()}
        </span>
      )}
    </div>

    {/* TEXTO */}
    <div style={{ minWidth: 0 }}>
      <div style={{
        fontSize: 24,
        fontWeight: 800,
        color: 'var(--color-text)',
        marginBottom: 2,
        whiteSpace: 'nowrap'
      }}>
        🛰️ {t('amigos')}
      </div>
      <div style={{
        fontSize: 13,
        color: 'var(--color-muted)',
        whiteSpace: 'nowrap'
      }}>
        {t('amigos_gestiona')}
      </div>
    </div>

  </div>

  {/* BOTON VOLVER — siempre a la derecha, nunca cae */}
  <button
    onClick={() => navigate('/home')}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      background: 'var(--color-surface)',
      border: '1px solid var(--color-border)',
      color: 'var(--color-text)',
      padding: '10px 14px',
      borderRadius: 14,
      cursor: 'pointer',
      fontWeight: 700,
      fontSize: 13,
      transition: '0.2s',
      flexShrink: 0,
      whiteSpace: 'nowrap'
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-2px)'
      e.currentTarget.style.border = '1px solid #3b82f6'
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0px)'
      e.currentTarget.style.border = '1px solid var(--color-border)'
    }}
  >
    {t('amigos_volver')}
  </button>

</div>


      {/* TARJETA AGREGAR */}
      <div
        style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)',
          borderRadius: 22,
          padding: 20,
          marginBottom: 24
        }}
      >

        <div
          style={{
            color: 'var(--color-text)',
            fontSize: 18,
            fontWeight: 700,
            marginBottom: 10
          }}
        >
          {t('amigos_agregar_titulo')}
        </div>

        <div
          style={{
            fontSize: 13,
            color: 'var(--color-muted)',
            marginBottom: 18,
            lineHeight: 1.5
          }}
        >
          {t('amigos_agregar_desc')}
        </div>

        {/* TU ID */}
        <div style={{
        padding: 18,
        borderRadius: 18,
        border: '1px solid var(--color-border)',
        background: 'var(--color-bg)',
        marginTop: 18
        }}>

        <div style={{
            fontSize: 12,
            color: 'var(--color-muted)',
            marginBottom: 10,
            fontWeight: 700
        }}>
            {t('amigos_tu_id')}
        </div>

        {user?.user_metadata?.friend_id ? (

            <div style={{
            fontSize: 18,
            fontWeight: 700,
            color: '#60a5fa',
            wordBreak: 'break-word',
            letterSpacing: 1
            }}>
            {user.user_metadata.friend_id}
            </div>

        ) : (

            <div style={{
            fontSize: 14,
            color: '#f59e0b',
            lineHeight: 1.5
            }}>
            {t('amigos_sin_id_pre')}
            <br />
            {t('amigos_sin_id_post')}
            </div>

        )}

        </div>

        {/* INPUT */}
        <input
          type="text"
          placeholder={t('amigos_input_placeholder')}
          value={friendId}
            onChange={(e) =>
            setFriendId(
                e.target.value.toUpperCase().trim()
            )
            }

          style={{
            width: '100%',
            background: 'var(--color-bg)',
            border: '1px solid var(--color-border)',
            borderRadius: 14,
            padding: '14px 16px',
            color: 'var(--color-text)',
            outline: 'none',
            marginBottom: 14,
            boxSizing: 'border-box'
          }}
        />

        {/* BOTON */}
        <button
          onClick={sendFriendRequest}
          disabled={sending}
          style={{
            width: '100%',
            background: 'var(--color-primary)',
            border: 'none',
            borderRadius: 14,
            padding: '14px 16px',
            color: 'white',
            fontWeight: 700,
            cursor: 'pointer',
            opacity: sending ? 0.6 : 1
          }}
        >
          {sending
            ? t('amigos_enviando')
            : t('amigos_anadir_btn')}
        </button>

      </div>

{/* SOLICITUDES PENDIENTES */}
<div style={{ marginBottom: 30 }}>

  <div
    style={{
      fontSize: 18,
      fontWeight: 700,
      color: 'var(--color-text)',
      marginBottom: 14
    }}
  >
    {t('amigos_solicitudes_titulo')}
  </div>

  {pendingRequests.length === 0 ? (

    <div
      style={{
        background: 'var(--color-surface)',
        border: '1px solid var(--color-border)',
        borderRadius: 18,
        padding: 20,
        color: 'var(--color-muted)',
        textAlign: 'center'
      }}
    >
      {t('amigos_sin_solicitudes')}
    </div>

  ) : (

    pendingRequests.map((request) => (

      <div
        key={request.id}
        style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)',
          borderRadius: 18,
          padding: 18,
          marginBottom: 12
        }}
      >

        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 12,
          flexWrap: 'wrap'
        }}>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12
            }}>

            {/* FOTO */}
            <div
                style={{
                width: 50,
                height: 50,
                borderRadius: '50%',
                overflow: 'hidden',
                background: 'rgba(59,130,246,0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
                }}
            >
            {request.profile?.avatar_path ? (

              <img
                src={getAvatarUrl(
                  request.profile.avatar_path
                )}
                alt="avatar"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />

            ) : (

              <span style={{ fontSize: 22 }}>
                👤
              </span>

            )}

            </div>

            {/* INFO */}
            <div>

              <div style={{
                color: 'white',
                fontWeight: 700,
                fontSize: 16,
                marginBottom: 2
              }}>
                {request.profile?.full_name || t('amigos_usuario_generico')}
              </div>

              <div style={{
                fontSize: 12,
                color: 'var(--color-muted)'
              }}>
                {t('amigos_id_label')} {request.profile?.friend_id || t('amigos_sin_id')}
              </div>

            </div>

            </div>

          <div style={{
            display: 'flex',
            gap: 10
          }}>

            <button
              onClick={() => {

              setSelectedRequest(request)

              setFriendNickname(
                request.profile?.full_name || ''
              )

              setShowAcceptModal(true)

            }}
              style={{
                border: 'none',
                borderRadius: 12,
                padding: '10px 14px',
                background: '#22c55e',
                color: 'white',
                fontWeight: 700,
                cursor: 'pointer'
              }}
            >
              {t('amigos_aceptar')}
            </button>

            <button
              onClick={() =>
                rejectRequest(request.id)
              }
              style={{
                border: 'none',
                borderRadius: 12,
                padding: '10px 14px',
                background: '#ef4444',
                color: 'white',
                fontWeight: 700,
                cursor: 'pointer'
              }}
            >
              {t('amigos_rechazar')}
            </button>

          </div>

        </div>

      </div>

    ))

  )}

</div>
      {/* LISTA */}
      <div>

        <div
          style={{
            fontSize: 18,
            fontWeight: 700,
            color: 'var(--color-text)',
            marginBottom: 14
          }}
        >
          {t('amigos_tus_amigos_titulo')}
        </div>

        {friends.length === 0 ? (

          <div
            style={{
              background: 'var(--color-surface)',
              border: '1px solid var(--color-border)',
              borderRadius: 18,
              padding: 20,
              color: 'var(--color-muted)',
              textAlign: 'center'
            }}
          >
            {t('amigos_sin_amigos')}
          </div>

        ) : (

        friends.map((f) => (

          <div
            key={f.id}
            style={{
              background: 'var(--color-surface)',
              border: '1px solid var(--color-border)',
              borderRadius: 22,
              padding: 18,
              marginBottom: 14
            }}
          >

            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 14,
              flexWrap: 'wrap'
            }}>

              {/* IZQUIERDA */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 14
              }}>

                {/* FOTO */}
                <div style={{
                  width: 64,
                  height: 64,
                  borderRadius: '50%',
                  overflow: 'hidden',
                  background: 'var(--color-surface)',
                  border: '1px solid var(--color-border)',
                  flexShrink: 0
                }}>

                  {f.profile?.avatar_path ? (

                    <img
                      src={getAvatarUrl(
                        f.profile.avatar_path
                      )}
                      alt="avatar"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />

                  ) : (

                    <div style={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 26
                    }}>
                      👤
                    </div>

                  )}

                </div>

                {/* INFO */}
                <div>

                  {(() => {

                    const nickname =
                      f.user_id === user.id
                        ? f.nickname_user
                        : f.nickname_friend

                    const realName =
                      f.profile?.full_name || t('amigos_usuario_generico')

                    // nombre que se verá grande arriba
                    const displayName =
                      nickname &&
                      nickname.trim() !== ''
                        ? nickname
                        : realName

                    return (
                      <>

                        {/* NOMBRE PRINCIPAL */}
                        <div
                          style={{
                            color: 'var(--color-text)',
                            fontSize: 20,
                            fontWeight: 800,
                            marginBottom: 4
                          }}
                        >
                          {displayName}
                        </div>

                        {/* NOMBRE REAL */}
                        <div
                          style={{
                            color: 'var(--color-muted)',
                            fontSize: 13
                          }}
                        >
                          {realName}
                        </div>

                      </>
                    )

                  })()}

                </div>

              </div>

              {/* BOTONES */}
              <div style={{
                display: 'flex',
                gap: 10
              }}>

                {/* EDITAR */}
                <button
                  onClick={() => {

                    setSelectedRequest({
                      ...f,
                      profile: f.profile
                    })

                    setFriendNickname(

                      (
                        f.user_id === user.id
                          ? f.nickname_user
                          : f.nickname_friend
                      ) ||

                      f.profile?.full_name ||

                      ''
                    )

                    setShowAcceptModal(true)

                  }}
                  style={{
                    border: 'none',
                    borderRadius: 12,
                    padding: '10px 14px',
                    background: '#3b82f6',
                    color: 'white',
                    fontWeight: 700,
                    cursor: 'pointer'
                  }}
                >
                  {t('amigos_editar')}
                </button>

                {/* ELIMINAR */}
                <button
                  onClick={() => setConfirmDeleteFriendId(f.id)}
                  style={{
                    border: 'none',
                    borderRadius: 12,
                    padding: '10px 14px',
                    background: '#ef4444',
                    color: 'white',
                    fontWeight: 700,
                    cursor: 'pointer'
                  }}
                >
                  {t('amigos_eliminar')}
                </button>

              </div>

            </div>

          </div>

        ))

        )}
                       {/*Ficha de la persona*/}
               
                {showAcceptModal && selectedRequest && (

                  <div
                    style={{
                      position: 'fixed',
                      inset: 0,
                      background: 'rgba(0,0,0,0.65)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      zIndex: 999
                    }}
                  >

                    <div
                      style={{
                        width: '90%',
                        maxWidth: 420,
                        background: 'var(--color-surface)',
                        border: '1px solid var(--color-border)',
                        borderRadius: 24,
                        padding: 24
                      }}
                    >

                      {/* FOTO */}
                      <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: 18
                      }}>

                        <div style={{
                          width: 100,
                          height: 100,
                          borderRadius: '50%',
                          overflow: 'hidden',
                          background: 'var(--color-surface)',
                        }}>

                          {selectedRequest.profile?.avatar_path ? (

                            <img
                              src={getAvatarUrl(
                                selectedRequest.profile.avatar_path
                              )}
                              alt="avatar"
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                              }}
                            />

                          ) : (

                            <div style={{
                              width: '100%',
                              height: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: 40
                            }}>
                              👤
                            </div>

                          )}

                        </div>

                      </div>

                      {/* NOMBRE REAL */}
                      <div style={{
                        textAlign: 'center',
                        color: 'var(--color-text)',
                        fontSize: 22,
                        fontWeight: 700,
                        marginBottom: 6
                      }}>
                        {selectedRequest.profile?.full_name}
                      </div>

                      {/* ID */}
                      <div style={{
                        textAlign: 'center',
                        color: 'var(--color-muted)',
                        fontSize: 13,
                        marginBottom: 22
                      }}>
                        {t('amigos_id_label')} {selectedRequest.profile?.friend_id}
                      </div>

                      {/* INPUT */}
                      <div style={{
                        marginBottom: 20
                      }}>

                        <div style={{
                          color: 'var(--color-text)',
                          fontSize: 14,
                          marginBottom: 8,
                          fontWeight: 600
                        }}>
                          {t('amigos_nombre_personalizado')}
                        </div>

                        <input
                          type="text"
                          value={friendNickname}
                          onChange={(e) =>
                            setFriendNickname(e.target.value)
                          }
                          placeholder={t('amigos_alias_placeholder')}
                          style={{
                            width: '100%',
                            padding: '14px 16px',
                            borderRadius: 14,
                            border: '1px solid var(--color-border)',
                            background: 'var(--color-bg)',
                            color: 'var(--color-text)',
                            outline: 'none',
                            boxSizing: 'border-box'
                          }}
                        />

                      </div>

                      {/* BOTONES */}
                      <div style={{
                        display: 'flex',
                        gap: 12
                      }}>

                        <button
                          onClick={() => {

                            setShowAcceptModal(false)

                            setSelectedRequest(null)

                          }}
                          style={{
                            flex: 1,
                            padding: 14,
                            borderRadius: 14,
                            border: 'none',
                            background: '#ef4444',
                            color: 'white',
                            fontWeight: 700,
                            cursor: 'pointer'
                          }}
                        >
                          {t('amigos_cancelar')}
                        </button>

                        <button
                          onClick={acceptRequest}
                          style={{
                            flex: 1,
                            padding: 14,
                            borderRadius: 14,
                            border: 'none',
                            background:
                              'linear-gradient(135deg,#22c55e,#16a34a)',
                            color: 'white',
                            fontWeight: 700,
                            cursor: 'pointer'
                          }}
                        >
                          {t('amigos_guardar_amigo')}
                        </button>

                      </div>

                    </div>

                  </div>

                )}
           </div> {/* cierra "LISTA" */}

            {/* MODAL ELIMINAR AMIGO */}
            {confirmDeleteFriendId && (
              <ConfirmModal
                titulo={t('amigos_confirmar_eliminar_titulo')}
                mensaje={t('amigos_confirmar_eliminar_desc')}
                textoBoton={t('amigos_si_eliminar')}
                onConfirmar={confirmarEliminarAmigo}
                onCancelar={() => setConfirmDeleteFriendId(null)}
              />
            )}

    </div> 
  )
}